import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  itemFindByOption,
  createItem,
  getById,
  updateById,
  getTenantItemsCount,
  downloadItemTemplate,
  bulkItemImport,
  getBulkReport,
  getItemDetailsById,
  offlineItem,
  listDriver,
  listAdminUsers,
} from "@/services/item.js";

import { fetchPartnerMarketSegment } from "@/services/partner";

import {
  listCatalog,
  fetchPartnerCatalogTree,
  fetchTenantCatalogTree,
} from "@/services/catalog";

@Module({
  namespaced: true,
})
export default class Item extends VuexModule {
  // state

  public currentSearchCatalogId = "";
  public itemList = [];
  public currentReadItem = {};
  public currentItemLocationObject = {};
  public bulkReportList = [];
  public itemDetailsById = {};
  public driverList = [];
  public adminUsersList = [];
  public adminUsersType = "";

  public tenantCatalogList = [];
  public segmentType = "";
  public marketList = [];
  public marketCategory = [];
  public catalogList = [];
  public selectedMarketId = { text: "Select Market", value: "" };
  public selectedMarketCategoryId = { text: "Select Category", value: "" };
  public selectedCatalogId = { text: "Select Catalog", value: "" };
  public itemTableField = [];
  public itemTableData = [];
  // actions

  @Action
  public async fetchDriverList() {
    try {
      const data = await listDriver();
      this.context.commit("setDriverList", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchAdminUsersByType(payload) {
    try {
      const requestedType = (payload && payload.userType
        ? String(payload.userType)
        : ""
      ).toUpperCase();
      const apiUserType =
        requestedType && requestedType !== "AGENT" ? requestedType : undefined;
      const data = await listAdminUsers(apiUserType);
      const responsePayload: any = data;
      const users =
        data?.data?.response ||
        responsePayload?.response ||
        data?.data?.data?.response ||
        data?.data?.data ||
        [];
      const parsedUsers = Array.isArray(users) ? users : [];
      const firstUser: any = parsedUsers[0] || {};
      const detectedType = String(
        firstUser.userType ||
          firstUser.type ||
          firstUser.role ||
          firstUser.profileType ||
          firstUser.accountType ||
          requestedType ||
          "AGENT",
      ).toUpperCase();
      const resolvedType = ["AGENT", "DRIVER", "DOCTOR"].includes(detectedType)
        ? detectedType
        : requestedType || "AGENT";

      this.context.commit("setAdminUsersData", {
        userType: resolvedType,
        users: parsedUsers,
      });
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchItemsByCatalog(payload) {
    try {
      const data = await itemFindByOption(payload);
      this.context.commit("setItemList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchItemDetailsById(payload) {
    try {
      const data = await getItemDetailsById(payload);
      this.context.commit("setItemDetailsById", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createItem(payload) {
    try {
      const data = await createItem(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async downloadItemTemplate(payload) {
    try {
      const data = await downloadItemTemplate(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async bulkItemImport(payload) {
    try {
      const data = await bulkItemImport(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getBulkReport(payload) {
    try {
      const response = await getBulkReport(payload);
      this.context.commit("setBulkReport", response.data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchItemById(payload) {
    try {
      const data = await getById(payload);
      this.context.commit("setCurrentReadItem", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateItemById(payload) {
    try {
      const data = await updateById(payload.id, payload.object);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async setItemCatalogLocation(payload) {
    try {
      this.context.commit("setCatalogLocation", payload);
      return payload;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTenantsItemCount() {
    try {
      const data = await getTenantItemsCount();
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async loadTenantCatelogTree() {
    try {
      const data = await fetchTenantCatalogTree();
      this.context.commit("setCatalogListFromTree", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async loadPartnerCatalogTree() {
    try {
      const data = await fetchPartnerCatalogTree();
      this.context.commit("setCatalogList", data.response);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async loadPartnerMarketSegment() {
    try {
      const data = await fetchPartnerMarketSegment({});
      this.context.commit("setSegmentAndMarket", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchCatalogList(params) {
    try {
      let searchQuery = params ? params : "";
      const data = await listCatalog(searchQuery);
      this.context.commit("setMarketCategory", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchCatalogListByMarketCategory(params) {
    try {
      let searchQuery = params ? params : "";
      const data = await listCatalog(searchQuery);
      this.context.commit("setCatalogList", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async changeMarketId(payload) {
    try {
      this.context.commit("setMarketId", payload);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async changeMarketCategory(payload) {
    try {
      this.context.commit("setMarketCategoryId", payload);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async changeCatelogId(payload) {
    try {
      this.context.commit("setCatelogId", payload);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async storeItemTableData(payload) {
    try {
      this.context.commit("setItemTableData", payload);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async offlineItem(payload) {
    try {
      const data = await offlineItem(payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  // mutations

  @Mutation
  public setDriverList(data: any) {
    this.driverList = data;
  }

  @Mutation
  public setAdminUsersData(payload: any) {
    const userType = String(payload?.userType || "").toUpperCase();
    const users = Array.isArray(payload?.users) ? payload.users : [];
    if (!["AGENT", "DRIVER", "DOCTOR"].includes(userType)) {
      return;
    }
    this.adminUsersType = userType;
    this.adminUsersList = users;
  }

  @Mutation
  public setMarketId(data: any) {
    this.selectedMarketId = data;
  }

  @Mutation
  public setMarketCategoryId(data: any) {
    this.selectedMarketCategoryId = data;
  }

  @Mutation
  public setCatelogId(data: any) {
    this.selectedCatalogId = data;
  }

  @Mutation
  public setItemTableData(data: any) {
    this.itemTableField = data.fields;
    this.itemTableData = data.items;
  }

  @Mutation
  public setCatalogListFromTree(data: any) {
    this.catalogList = [];
    if (data.length) {
      let arr = data
        .filter((Obj) => Obj.isProductType)
        .map((c) => ({ text: c.name, value: c._id }));
      this.catalogList = arr.reverse();
    }
  }

  @Mutation
  public setMarketCategory(data: any) {
    this.marketCategory = [];
    if (Array.isArray(data.data.response) && data.data.response.length)
      this.marketCategory = data.data.response.map((c) => ({
        text: c.name,
        value: c._id,
      }));
  }

  @Mutation
  public setCatalogList(data: any) {
    this.catalogList = [];
    if (Array.isArray(data.data.response) && data.data.response.length)
      this.catalogList = data.data.response.map((c) => ({
        text: c.name,
        value: c._id,
      }));
  }

  @Mutation
  public setSegmentAndMarket(data: any) {
    this.segmentType = "";
    this.marketList = [];
    this.marketCategory = [];
    // this.catalogList = [];
    this.segmentType = data.some((obj) => obj.isMarket) ? "MARKET" : "CATEGORY";
    if (this.segmentType === "MARKET") {
      this.marketList = data.map((c) => ({
        text: c.name,
        value: c._id,
      }));
    } else {
      this.marketCategory = data.map((c) => ({
        text: c.name,
        value: c._id,
      }));
    }
    // let arr = data
    //   .filter((Obj) => Obj.isProductType)
    //   .map((c) => ({ text: c.name, value: c._id }));
    // this.catalogList = arr.reverse();
  }

  @Mutation
  public setItemList(data: any) {
    this.itemList = data;
  }

  @Mutation
  public setItemDetailsById(data: any) {
    this.itemDetailsById = data;
  }

  @Mutation
  public setCurrentReadItem(data: any) {
    this.currentReadItem = data;
  }

  @Mutation
  public setCatalogLocation(data: any) {
    this.currentItemLocationObject = data;
  }

  @Mutation
  public setBulkReport(data) {
    this.bulkReportList = data;
  }

  // getters
  get GetDriverList() {
    return this.driverList;
  }

  get GetAdminUsersList() {
    return this.adminUsersList;
  }

  get GetAdminUsersType() {
    return this.adminUsersType;
  }

  get GetItemListByCatalog() {
    return this.itemList;
  }

  get GetCurrentItemObject() {
    return this.currentReadItem;
  }

  get GetCurrentCatalogLocation() {
    return this.currentItemLocationObject;
  }

  get GetBulkItemReport() {
    return this.bulkReportList;
  }

  get GetItemDetailsById() {
    return this.itemDetailsById;
  }
}
